import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';
import { getRTLPopperStyles } from '~/modules/common/util';
import { useSmartFitDialog } from '~/modules/resourcing/common/hooks';
import { useAllocationChartContext } from '~/modules/projects/resourcing-plan/ResourcingPlanPage/contexts';
import AcceptWithSmartFitDialog from '~/modules/resourcing/common/components/AcceptWithSmartFitDialog';
import useStyles from './useStyles';

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    display: 'flex'
  })
}));

export const ResourceMatchItemAcceptButton = ({
  dataQeId,
  resourceRequest,
  resourceUser
}) => {
  const classes = useStyles();
  const tooltipPopperClasses = useTooltipPopperStyles();
  const { formatMessage } = useIntl();
  const checkMarkDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemAcceptButton`
    : undefined;
  const acceptTooltipTitle = formatMessage({
    id: 'resourceMatchItem.acceptResource'
  });

  const allocationChartContext = useAllocationChartContext();

  const {
    isSmartFitOpen,
    smartFitState,
    openSmartFit,
    closeSmartFit
  } = useSmartFitDialog();

  const handleAccept = useCallback(
    _event => {
      openSmartFit({
        resourceRequest,
        resourceUser,
        allocationChartRef: allocationChartContext?.allocationChartRef
      });
    },
    [
      resourceRequest,
      resourceUser,
      allocationChartContext?.allocationChartRef,
      openSmartFit
    ]
  );

  return (
    <>
      <ButtonBase
        data-qe-id={checkMarkDataQeId}
        className={classes.itemButtonShadow}
        onClick={handleAccept}
      >
        <Tooltip
          title={acceptTooltipTitle}
          aria-label={acceptTooltipTitle}
          aria-hidden={false}
          placement="bottom-start"
          classes={tooltipPopperClasses}
        >
          <CheckCircle className={classes.acceptButtonIcon} />
        </Tooltip>
      </ButtonBase>
      {isSmartFitOpen && (
        <AcceptWithSmartFitDialog
          smartFitState={smartFitState}
          onClose={closeSmartFit}
        />
      )}
    </>
  );
};

ResourceMatchItemAcceptButton.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  resourceUser: PropTypes.object.isRequired
};

export default ResourceMatchItemAcceptButton;
